import { css } from '@emotion/react'
import FlipToFrontIcon from '@mui/icons-material/FlipToFront'
import { CSSProperties, memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import IconButton from './IconButton'

const buttonStyles = css({
    border: 0,
    padding: getThemeSpacing(1),
})

interface FullWindowButtonProps {
    onClick(event?: any): void
    style?: CSSProperties
}

const ButtonFullWindowEnter = memo(
    ({ onClick, style }: FullWindowButtonProps) => (
        <IconButton
            title="Interactive Full Screen"
            onClick={onClick}
            css={buttonStyles}
            style={style}
        >
            <FlipToFrontIcon data-testid="FlipToFrontIcon" />
        </IconButton>
    ),
)

export default ButtonFullWindowEnter
